import * as muistyles from "@mui/styles";
import Welcome from 'src/app/pages/Welcome'

export default muistyles.withTheme(Welcome as any);